/**
 * @generated SignedSource<<7020c560a72245f799690489971f5ae8>>
 * @relayHash 9629e4585ae11dd33e856d3b867ae4f6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/441.0.0-2023-12-07T14:38:11.118Z/pdpRespRootQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type pdpRespRootQuery$variables = {
  fetchAuction?: boolean | null;
  fetchFollowSearch: boolean;
  fetchPdp: boolean;
  fetchRegionalInfo?: boolean | null;
  fetchUser: boolean;
  followSearchPages?: ReadonlyArray<string | null> | null;
  forcedCurrency?: Currency | null;
  isBuyerCancelationPolicyVariant?: boolean | null;
  isClient: boolean;
  isEuReturnPolicyVariant?: boolean | null;
  isInteractivePdpChat?: boolean | null;
  isMultiSku: boolean;
  isTopYmalVariant?: boolean | null;
  isTrade: boolean;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  itemQuantity?: number | null;
  priceBookName?: string | null;
  timezoneOffset?: number | null;
  userCountryCode?: string | null;
  userId?: string | null;
  userIds?: ReadonlyArray<string | null> | null;
  userZipCode?: string | null;
};
export type pdpRespRootQuery$data = {
  readonly viewer: {
    readonly itemRead: ReadonlyArray<{
      readonly isAuctionEnabled?: boolean | null;
      readonly isFurniture?: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"findPdpItemReadError_itemRead" | "handlePdpStatuses_item">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespLayout_viewer">;
  };
};
export type pdpRespRootQuery = {
  response: pdpRespRootQuery$data;
  variables: pdpRespRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAuction"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchFollowSearch"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchPdp"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forcedCurrency"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isBuyerCancelationPolicyVariant"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isEuReturnPolicyVariant"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isInteractivePdpChat"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMultiSku"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTopYmalVariant"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemIds"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v17 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timezoneOffset"
},
v19 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v20 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v22 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v23 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFurniture",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAuctionEnabled",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingListed",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingNotListed",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingUnlisted",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingMigrated",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNew",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWip",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSold",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternal",
  "storageKey": null
},
v39 = {
  "kind": "Literal",
  "name": "metricTypes",
  "value": [
    "LISTING_VIEWS"
  ]
},
v40 = [
  (v39/*: any*/),
  {
    "kind": "Literal",
    "name": "timeRange",
    "value": "LAST_6_MONTHS"
  }
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v42 = [
  (v41/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivateVisibilityType",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrivateListing",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirectType",
  "kind": "LinkedField",
  "name": "redirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageType",
      "storageKey": null
    }
  ],
  "type": "ItemReadError",
  "abstractKey": null
},
v48 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v49 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v50 = {
  "kind": "Literal",
  "name": "seller",
  "value": "EXCLUDE"
},
v51 = [
  {
    "kind": "Literal",
    "name": "excludeAuctionItems",
    "value": true
  },
  (v48/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPath",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attribution",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v57/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v58/*: any*/),
        (v59/*: any*/)
      ],
      "storageKey": null
    },
    (v59/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v64 = [
  (v62/*: any*/),
  (v63/*: any*/)
],
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": (v64/*: any*/),
  "storageKey": null
},
v66 = {
  "kind": "Literal",
  "name": "page",
  "value": "searchAndBrowse"
},
v67 = [
  (v66/*: any*/)
],
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasReserve",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reserveMet",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "AuctionBidsConnection",
  "kind": "LinkedField",
  "name": "bids",
  "plural": false,
  "selections": [
    (v70/*: any*/)
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": (v67/*: any*/),
  "concreteType": "AuctionSolution",
  "kind": "LinkedField",
  "name": "relevantAuctionSolution",
  "plural": false,
  "selections": [
    (v68/*: any*/),
    (v59/*: any*/),
    (v69/*: any*/),
    (v71/*: any*/)
  ],
  "storageKey": "relevantAuctionSolution(page:\"searchAndBrowse\")"
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": (v67/*: any*/),
  "concreteType": "AuctionLot",
  "kind": "LinkedField",
  "name": "relevantAuctionLot",
  "plural": false,
  "selections": [
    (v73/*: any*/),
    (v59/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/)
  ],
  "storageKey": "relevantAuctionLot(page:\"searchAndBrowse\")"
},
v77 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v78 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v79 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v83 = [
  (v81/*: any*/),
  (v82/*: any*/)
],
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v83/*: any*/),
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantityDisplay",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentageOff",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPriceLabel",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": [
    (v77/*: any*/),
    (v66/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v80/*: any*/),
    (v84/*: any*/),
    (v85/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplimentary",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmounts",
  "kind": "LinkedField",
  "name": "convertedAmounts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "USD",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v93 = [
  (v92/*: any*/)
],
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "totalAmount",
  "plural": false,
  "selections": (v93/*: any*/),
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v91/*: any*/),
    (v94/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            (v59/*: any*/)
          ],
          "storageKey": null
        },
        (v59/*: any*/)
      ],
      "storageKey": null
    },
    (v59/*: any*/)
  ],
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isStorefrontOnly",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v27/*: any*/),
                (v58/*: any*/),
                (v99/*: any*/),
                (v59/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v59/*: any*/)
  ],
  "storageKey": null
},
v101 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "originalConvertedAmountList",
    "plural": true,
    "selections": (v83/*: any*/),
    "storageKey": null
  }
],
v102 = {
  "alias": "originalDisplayPrice",
  "args": (v67/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": (v101/*: any*/),
  "storageKey": "displayPrice(page:\"searchAndBrowse\")"
},
v103 = [
  (v84/*: any*/)
],
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPricing",
  "kind": "LinkedField",
  "name": "pricing",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "retailPrice",
      "plural": false,
      "selections": (v103/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v105 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "alias": "mobileTitle",
      "args": (v105/*: any*/),
      "kind": "ScalarField",
      "name": "title",
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        (v106/*: any*/),
        {
          "alias": "mobileText",
          "args": (v105/*: any*/),
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v58/*: any*/),
        (v65/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v108 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v41/*: any*/)
],
v109 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v108/*: any*/),
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v110 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placeholder",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webPath",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    (v113/*: any*/)
  ],
  "storageKey": null
},
v115 = {
  "alias": "productPhotos",
  "args": (v110/*: any*/),
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v111/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    (v112/*: any*/),
    (v114/*: any*/),
    (v59/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v118 = [
  (v48/*: any*/),
  (v49/*: any*/),
  {
    "kind": "Literal",
    "name": "seller",
    "value": "INCLUDE"
  }
],
v119 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "moreLikeThisItemEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Item",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v52/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v27/*: any*/),
          (v36/*: any*/),
          (v26/*: any*/),
          (v24/*: any*/),
          (v55/*: any*/),
          (v28/*: any*/),
          (v56/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/),
          (v65/*: any*/),
          (v72/*: any*/),
          (v76/*: any*/),
          (v89/*: any*/),
          (v25/*: any*/),
          (v90/*: any*/),
          (v95/*: any*/),
          (v96/*: any*/),
          (v97/*: any*/),
          (v98/*: any*/),
          (v100/*: any*/),
          (v102/*: any*/),
          (v104/*: any*/),
          (v107/*: any*/),
          (v109/*: any*/),
          (v115/*: any*/),
          (v59/*: any*/),
          (v46/*: any*/)
        ],
        "storageKey": null
      },
      (v116/*: any*/)
    ],
    "storageKey": null
  },
  (v117/*: any*/)
],
v120 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v121 = [
  (v49/*: any*/),
  (v120/*: any*/)
],
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v123 = [
  (v122/*: any*/),
  (v59/*: any*/)
],
v124 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v125 = {
  "kind": "Variable",
  "name": "country",
  "variableName": "userCountryCode"
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v128 = [
  (v59/*: any*/)
],
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnlimitedQuantity",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v134 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v135 = [
  (v134/*: any*/),
  (v77/*: any*/),
  (v78/*: any*/),
  (v79/*: any*/)
],
v136 = [
  (v82/*: any*/),
  (v81/*: any*/)
],
v137 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "originalConvertedAmountList",
  "plural": true,
  "selections": (v136/*: any*/),
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v136/*: any*/),
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "privateOfferConvertedAmountList",
  "plural": true,
  "selections": (v136/*: any*/),
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerExpirationDate",
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVatIncluded",
  "storageKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceBookName",
  "storageKey": null
},
v143 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "currency",
      "value": "USD"
    }
  ],
  "kind": "ScalarField",
  "name": "convertedAmount",
  "storageKey": "convertedAmount(currency:\"USD\")"
},
v144 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "timezoneOffset",
      "variableName": "timezoneOffset"
    }
  ],
  "concreteType": "HolidayShippingEstimationsType",
  "kind": "LinkedField",
  "name": "holidayShippingEstimations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termsAndConditions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ValidHolidayShippingDays",
      "kind": "LinkedField",
      "name": "validHolidayShippingDays",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shipmentQuoteId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedDeliveryDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v145 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v146 = {
  "alias": null,
  "args": (v145/*: any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v147 = [
  (v134/*: any*/)
],
v148 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v149 = {
  "kind": "Literal",
  "name": "feedbackSellerPublicNoteHasText",
  "value": true
},
v150 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v151 = {
  "kind": "Literal",
  "name": "minimumReviewRating",
  "value": 4
},
v152 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v153 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v152/*: any*/)
  ],
  "storageKey": null
},
v154 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caption",
  "storageKey": null
},
v155 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaType",
  "storageKey": null
},
v156 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v157 = {
  "kind": "InlineFragment",
  "selections": (v128/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v158 = [
  (v27/*: any*/),
  (v59/*: any*/)
],
v159 = [
  {
    "kind": "Literal",
    "name": "fullCountryName",
    "value": true
  }
],
v160 = [
  (v46/*: any*/),
  (v59/*: any*/)
],
v161 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v162 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v163 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v158/*: any*/),
  "storageKey": null
},
v164 = [
  (v120/*: any*/)
],
v165 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
],
v166 = [
  (v52/*: any*/),
  (v53/*: any*/),
  (v54/*: any*/),
  (v27/*: any*/),
  (v36/*: any*/),
  (v26/*: any*/),
  (v24/*: any*/),
  (v55/*: any*/),
  (v28/*: any*/),
  (v56/*: any*/),
  (v60/*: any*/),
  (v61/*: any*/),
  (v65/*: any*/),
  (v72/*: any*/),
  (v76/*: any*/),
  (v89/*: any*/),
  (v25/*: any*/),
  (v90/*: any*/),
  (v95/*: any*/),
  (v96/*: any*/),
  (v97/*: any*/),
  (v98/*: any*/),
  (v100/*: any*/),
  (v102/*: any*/),
  (v104/*: any*/),
  (v107/*: any*/),
  (v109/*: any*/),
  (v115/*: any*/),
  (v59/*: any*/)
],
v167 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpURL",
  "storageKey": null
},
v168 = [
  (v106/*: any*/),
  (v62/*: any*/)
],
v169 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v170 = {
  "alias": null,
  "args": (v135/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v137/*: any*/),
    (v139/*: any*/),
    (v85/*: any*/),
    (v86/*: any*/),
    (v80/*: any*/),
    (v87/*: any*/),
    (v88/*: any*/),
    (v140/*: any*/),
    (v141/*: any*/),
    (v142/*: any*/)
  ],
  "storageKey": null
},
v171 = {
  "alias": null,
  "args": null,
  "concreteType": "Hold",
  "kind": "LinkedField",
  "name": "activeHold",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTimeToExpire",
      "storageKey": null
    },
    (v59/*: any*/)
  ],
  "storageKey": null
},
v172 = {
  "kind": "Literal",
  "name": "page",
  "value": "pdp"
},
v173 = [
  (v134/*: any*/),
  (v172/*: any*/)
],
v174 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMakeOffer",
  "storageKey": null
},
v175 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showHoldRequest",
  "storageKey": null
},
v176 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPurchase",
  "storageKey": null
},
v177 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showRequestPrice",
  "storageKey": null
},
v178 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showFollowCategory",
  "storageKey": null
},
v179 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAcceptOffer",
  "storageKey": null
},
v180 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCategory",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "precedence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            (v126/*: any*/),
            (v36/*: any*/),
            (v59/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v181 = [
  (v172/*: any*/)
],
v182 = {
  "alias": null,
  "args": (v147/*: any*/),
  "concreteType": "Transaction",
  "kind": "LinkedField",
  "name": "lastTransaction",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Offer",
      "kind": "LinkedField",
      "name": "secondChanceOffer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "amountPerItem",
          "plural": false,
          "selections": (v93/*: any*/),
          "storageKey": null
        },
        (v59/*: any*/)
      ],
      "storageKey": null
    },
    (v59/*: any*/)
  ],
  "storageKey": null
},
v183 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v184 = [
  (v126/*: any*/)
],
v185 = [
  (v126/*: any*/),
  (v59/*: any*/)
],
v186 = {
  "alias": null,
  "args": null,
  "concreteType": "MCAnalytics",
  "kind": "LinkedField",
  "name": "analytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalyticsMetrics",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCMetricResponseTime",
          "kind": "LinkedField",
          "name": "responseTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summaryCopy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v187 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      (v174/*: any*/)
    ],
    "storageKey": null
  }
],
v188 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v189 = {
  "alias": null,
  "args": (v181/*: any*/),
  "concreteType": "AuctionLot",
  "kind": "LinkedField",
  "name": "relevantAuctionLot",
  "plural": false,
  "selections": [
    (v73/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/),
    (v59/*: any*/)
  ],
  "storageKey": "relevantAuctionLot(page:\"pdp\")"
},
v190 = {
  "alias": null,
  "args": (v181/*: any*/),
  "concreteType": "AuctionSolution",
  "kind": "LinkedField",
  "name": "relevantAuctionSolution",
  "plural": false,
  "selections": [
    (v69/*: any*/),
    (v59/*: any*/)
  ],
  "storageKey": "relevantAuctionSolution(page:\"pdp\")"
},
v191 = [
  (v92/*: any*/),
  (v84/*: any*/)
],
v192 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "openingBid",
  "plural": false,
  "selections": (v103/*: any*/),
  "storageKey": null
},
v193 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "reservePrice",
  "plural": false,
  "selections": (v103/*: any*/),
  "storageKey": null
},
v194 = [
  (v81/*: any*/)
],
v195 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnavailable",
  "storageKey": null
},
v196 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanceled",
  "storageKey": null
},
v197 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkoutDate",
  "storageKey": null
},
v198 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExpired",
  "storageKey": null
},
v199 = [
  (v81/*: any*/),
  (v82/*: any*/),
  (v138/*: any*/)
],
v200 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v201 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "associationType",
  "storageKey": null
},
v202 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v203 = [
  (v134/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
],
v204 = {
  "kind": "Literal",
  "name": "auctionModule",
  "value": true
},
v205 = [
  {
    "kind": "Literal",
    "name": "auctionEnabled",
    "value": true
  },
  (v204/*: any*/),
  {
    "kind": "Literal",
    "name": "excludeAuctionItems",
    "value": false
  },
  (v48/*: any*/),
  (v77/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/)
],
v206 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pdpRespRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespLayout_viewer"
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "handlePdpStatuses_item",
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": "relevantAuctionLotRedirect",
                        "args": null,
                        "concreteType": "AuctionLot",
                        "kind": "LinkedField",
                        "name": "relevantAuctionLot",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v40/*: any*/),
                        "concreteType": "MetricDetailType",
                        "kind": "LinkedField",
                        "name": "metrics",
                        "plural": true,
                        "selections": (v42/*: any*/),
                        "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                      },
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "findPdpItemReadError_itemRead",
                "selections": [
                  (v46/*: any*/),
                  (v47/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v13/*: any*/),
      (v11/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v22/*: any*/),
      (v19/*: any*/),
      (v3/*: any*/),
      (v17/*: any*/),
      (v10/*: any*/),
      (v18/*: any*/),
      (v0/*: any*/),
      (v16/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Operation",
    "name": "pdpRespRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "klarnaOnSiteMessagingEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "KLARNA_OSM"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"KLARNA_OSM\")"
          },
          {
            "alias": "klarnaNegotiationEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "klarnaNegotiationFlow"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"klarnaNegotiationFlow\")"
          },
          {
            "alias": "isWordpressArticlesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "WP_EDITORIAL"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
          },
          {
            "alias": "pdpOptinPromptFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "pdpOptinPrompt"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"pdpOptinPrompt\")"
          },
          {
            "alias": "isPopularSearchesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "popularSearches"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"popularSearches\")"
          },
          {
            "alias": "pdpHolidayShippingFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "HOLIDAY_SHIPPING"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"HOLIDAY_SHIPPING\")"
          },
          {
            "alias": "ymalItems",
            "args": (v51/*: any*/),
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v36/*: any*/),
                      (v26/*: any*/),
                      (v24/*: any*/),
                      (v55/*: any*/),
                      (v28/*: any*/),
                      (v56/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v65/*: any*/),
                      (v72/*: any*/),
                      (v76/*: any*/),
                      (v89/*: any*/),
                      (v25/*: any*/),
                      (v90/*: any*/),
                      (v95/*: any*/),
                      (v96/*: any*/),
                      (v97/*: any*/),
                      (v98/*: any*/),
                      (v100/*: any*/),
                      (v102/*: any*/),
                      (v104/*: any*/),
                      (v107/*: any*/),
                      (v109/*: any*/),
                      (v115/*: any*/),
                      (v59/*: any*/),
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v116/*: any*/)
                ],
                "storageKey": null
              },
              (v117/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "ymalItems",
            "args": (v51/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "PdpRespYMALItemsCarousel_ymalItems",
            "kind": "LinkedHandle",
            "name": "moreLikeThisItem"
          },
          {
            "alias": "sellerItems",
            "args": (v118/*: any*/),
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": (v119/*: any*/),
            "storageKey": null
          },
          {
            "alias": "sellerItems",
            "args": (v118/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "PdpRespSellerItemsCarousel_sellerItems",
            "kind": "LinkedHandle",
            "name": "moreLikeThisItem"
          },
          {
            "alias": null,
            "args": (v121/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v123/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "gdprDisplayInfo",
            "kind": "LinkedField",
            "name": "gdprDisplayInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v124/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "isGdprApplicable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "marketingOptInMessage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "detectFeedbackLanguage",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "detectFeedbackLanguage"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
          },
          {
            "alias": null,
            "args": [
              (v125/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "isCountryInEu",
            "storageKey": null
          },
          {
            "alias": "isMultiItemCart",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "multiItemCart"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"multiItemCart\")"
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v46/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isItemReadType"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  (v97/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PricingGuidance",
                    "kind": "LinkedField",
                    "name": "pricingGuidance",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceRange",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rareFind",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pricingGuidanceType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "price",
                        "plural": false,
                        "selections": (v103/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SaveSearchDataType",
                    "kind": "LinkedField",
                    "name": "saveSearchData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "page",
                        "storageKey": null
                      },
                      (v126/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "skus",
                    "plural": true,
                    "selections": [
                      (v127/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v128/*: any*/),
                        "storageKey": null
                      },
                      (v59/*: any*/),
                      (v27/*: any*/),
                      (v129/*: any*/),
                      (v130/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SkuQuantityOption",
                        "kind": "LinkedField",
                        "name": "quantitySelectOptions",
                        "plural": true,
                        "selections": [
                          (v131/*: any*/),
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "setSize",
                        "storageKey": null
                      },
                      {
                        "condition": "isMultiSku",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SkuRingSizeDisplay",
                            "kind": "LinkedField",
                            "name": "ringSizeDisplay",
                            "plural": false,
                            "selections": [
                              (v132/*: any*/),
                              (v133/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v135/*: any*/),
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": [
                              (v137/*: any*/),
                              (v138/*: any*/),
                              (v139/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v80/*: any*/),
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v140/*: any*/),
                              (v141/*: any*/),
                              (v142/*: any*/),
                              (v143/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "isClient",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v144/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  (v146/*: any*/),
                  {
                    "alias": "itemIsOnHold",
                    "args": (v147/*: any*/),
                    "kind": "ScalarField",
                    "name": "isOnHold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoryTellingModule",
                    "kind": "LinkedField",
                    "name": "storyTellingModule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryTellingTab",
                        "kind": "LinkedField",
                        "name": "tabs",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticlesType",
                            "kind": "LinkedField",
                            "name": "supplementaryEditorial",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WordpressArticleType",
                                "kind": "LinkedField",
                                "name": "articles",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publishedDate",
                                    "storageKey": null
                                  },
                                  (v26/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WordpressArticleImageType",
                                    "kind": "LinkedField",
                                    "name": "imageUrl",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "full",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subtitle",
                                    "storageKey": null
                                  },
                                  (v148/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "source",
                                    "storageKey": null
                                  },
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v35/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      (v38/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v59/*: any*/),
                      (v27/*: any*/),
                      (v73/*: any*/),
                      {
                        "alias": "dealerDetailsOrderFeedbackPdpResp",
                        "args": [
                          (v149/*: any*/),
                          (v150/*: any*/),
                          (v151/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "sortBy",
                            "value": "sellerExperienceDesc"
                          }
                        ],
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "kind": "LinkedField",
                        "name": "orderFeedbackPdp",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedbackPdp",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "completedDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Transaction",
                                    "kind": "LinkedField",
                                    "name": "transaction",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "buyer",
                                        "plural": false,
                                        "selections": [
                                          (v153/*: any*/),
                                          (v59/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Shipment",
                                        "kind": "LinkedField",
                                        "name": "shipment",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Address",
                                            "kind": "LinkedField",
                                            "name": "shippingAddress",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "displayState",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "displayCountry",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "country",
                                                "storageKey": null
                                              },
                                              (v59/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v59/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v59/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "overallExperience",
                                    "plural": false,
                                    "selections": [
                                      (v46/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "rating",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "publicNote",
                                    "plural": false,
                                    "selections": [
                                      (v46/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "freetext",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
                      },
                      {
                        "alias": "isRewardsTier2",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listName",
                            "value": "SELLER_REWARDS_2"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "isAnchorListMember",
                        "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StorefrontProfile",
                        "kind": "LinkedField",
                        "name": "liveStorefrontProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aboutUsUnbranded",
                            "storageKey": null
                          },
                          (v59/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaAlbum",
                            "kind": "LinkedField",
                            "name": "galleryAlbum",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaElement",
                                "kind": "LinkedField",
                                "name": "mediaList",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "element",
                                    "plural": false,
                                    "selections": [
                                      (v46/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v62/*: any*/),
                                          (v154/*: any*/),
                                          (v155/*: any*/)
                                        ],
                                        "type": "Photo",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v156/*: any*/),
                                          (v154/*: any*/),
                                          (v155/*: any*/)
                                        ],
                                        "type": "Video",
                                        "abstractKey": null
                                      },
                                      (v157/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "headshots",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "photoType",
                                "value": "DEALER_STOREFRONT_HEADSHOT"
                              }
                            ],
                            "concreteType": "Photo",
                            "kind": "LinkedField",
                            "name": "photos",
                            "plural": true,
                            "selections": [
                              (v73/*: any*/),
                              (v62/*: any*/),
                              (v59/*: any*/)
                            ],
                            "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "establishmentYear",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "kind": "LinkedField",
                        "name": "orderFeedbackPdp",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AggregatedOrderFeedbackType",
                                "kind": "LinkedField",
                                "name": "aggregatedFeedback",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AggregatedOrderFeedbackQuestionType",
                                    "kind": "LinkedField",
                                    "name": "overallExperience",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mean",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publicNoteTotalResults",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedbackPdp",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v158/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "monthsSinceStartDate",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "unit",
                            "value": "MONTH"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "timeSinceStartDate",
                        "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerProfile",
                        "kind": "LinkedField",
                        "name": "sellerProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "company",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "shippingAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "displayFullCityStateCountry",
                            "args": (v159/*: any*/),
                            "kind": "ScalarField",
                            "name": "displayCityStateCountry",
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "dealerDetailsHeaderFeedback",
                        "args": [
                          (v149/*: any*/),
                          (v150/*: any*/),
                          (v151/*: any*/)
                        ],
                        "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                        "kind": "LinkedField",
                        "name": "orderFeedbackPdp",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedbackPdp",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v160/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDistinguished",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SellerTiers",
                        "kind": "LinkedField",
                        "name": "sellerTiers",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isGoldTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPlatinumTier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sellerTierDataNotFound",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "agreementStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sellerOrderQuantity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MCAnalytics",
                        "kind": "LinkedField",
                        "name": "analytics",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MCAnalyticsMetrics",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MCMetricResponseTime",
                                "kind": "LinkedField",
                                "name": "responseTime",
                                "plural": false,
                                "selections": (v42/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeAssociation",
                        "kind": "LinkedField",
                        "name": "tradeAssociations",
                        "plural": true,
                        "selections": [
                          (v27/*: any*/),
                          (v58/*: any*/),
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelrySeller",
                        "storageKey": null
                      },
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v106/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      (v161/*: any*/),
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "sortedPhotos",
                    "plural": true,
                    "selections": [
                      (v161/*: any*/),
                      (v162/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSkuXref",
                        "kind": "LinkedField",
                        "name": "imageSkuXrefs",
                        "plural": true,
                        "selections": [
                          (v127/*: any*/),
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v61/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v126/*: any*/),
                          (v58/*: any*/),
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUnpurchasable",
                    "storageKey": null
                  },
                  {
                    "alias": "priceType",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "buyerId",
                        "value": ""
                      },
                      {
                        "kind": "Literal",
                        "name": "isTrade",
                        "value": false
                      }
                    ],
                    "concreteType": "ItemDisplayPriceType",
                    "kind": "LinkedField",
                    "name": "displayPrice",
                    "plural": true,
                    "selections": [
                      (v80/*: any*/)
                    ],
                    "storageKey": "displayPrice(buyerId:\"\",isTrade:false)"
                  },
                  (v43/*: any*/),
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contemporaryTrackingString",
                    "storageKey": null
                  },
                  (v90/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPricing",
                    "kind": "LinkedField",
                    "name": "pricing",
                    "plural": false,
                    "selections": [
                      (v94/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": (v147/*: any*/),
                    "kind": "ScalarField",
                    "name": "isDepositAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemAttributes",
                    "kind": "LinkedField",
                    "name": "attributes",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "leadTime",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AttributeOption",
                            "kind": "LinkedField",
                            "name": "option",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlLabel",
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "customizable",
                        "plural": true,
                        "selections": [
                          (v163/*: any*/),
                          (v106/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AttributeValue",
                        "kind": "LinkedField",
                        "name": "ringResizable",
                        "plural": true,
                        "selections": [
                          (v163/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v164/*: any*/),
                    "concreteType": "ReturnPolicy",
                    "kind": "LinkedField",
                    "name": "returnPolicy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReturnPolicyCopy",
                        "kind": "LinkedField",
                        "name": "buyerCopy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "returnPolicySectionHeader",
                            "plural": false,
                            "selections": (v165/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "isEuReturnPolicyVariant",
                                "variableName": "isEuReturnPolicyVariant"
                              },
                              (v79/*: any*/)
                            ],
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "returnPolicySection",
                            "plural": false,
                            "selections": (v165/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "customizableDetailReturnCopy",
                            "plural": false,
                            "selections": (v165/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InlineCtaCopy",
                            "kind": "LinkedField",
                            "name": "returnPolicySectionCtaCopy",
                            "plural": false,
                            "selections": (v165/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v59/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accept",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CollectionModule",
                    "kind": "LinkedField",
                    "name": "collectionModule",
                    "plural": false,
                    "selections": [
                      (v126/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 5
                          }
                        ],
                        "concreteType": "CollectionItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": [
                          (v70/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CollectionItemsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v166/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "items(first:5)"
                      },
                      (v65/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDeleted",
                    "storageKey": null
                  },
                  (v98/*: any*/),
                  (v167/*: any*/),
                  (v53/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isComplete",
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "popularSearchesLink",
                    "plural": false,
                    "selections": (v168/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "sitemapLinks",
                    "plural": true,
                    "selections": (v168/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "storyTelling",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "shortTitles",
                        "value": true
                      }
                    ],
                    "concreteType": "StoryTellingModule",
                    "kind": "LinkedField",
                    "name": "storyTellingModule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoryTellingTab",
                        "kind": "LinkedField",
                        "name": "tabs",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tabTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentHeader",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingModuleCreator",
                            "kind": "LinkedField",
                            "name": "contentCreatorAttribution",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "creatorName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "creatorBrowseUrl",
                                "plural": false,
                                "selections": (v64/*: any*/),
                                "storageKey": null
                              },
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentBodyText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainImage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainVideo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "browseLink",
                            "plural": false,
                            "selections": (v64/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "smallImage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "storyTellingModule(shortTitles:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCustomizable",
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seoDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PdpDetail",
                    "kind": "LinkedField",
                    "name": "pdpDetailsDisplay",
                    "plural": true,
                    "selections": [
                      (v169/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "delimiter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "detailDisplayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "detailValues",
                        "plural": true,
                        "selections": [
                          (v46/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isPdpDetailValueInterface"
                          },
                          (v169/*: any*/),
                          (v36/*: any*/),
                          (v58/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayDetails",
                            "storageKey": null
                          },
                          (v127/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "price",
                                "plural": false,
                                "selections": [
                                  (v138/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailVersionsValue",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RingSizeDetail",
                                "kind": "LinkedField",
                                "name": "ringSizes",
                                "plural": true,
                                "selections": (v108/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "PdpDetailRingSize",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v135/*: any*/),
                    "concreteType": "ItemDisplayPriceType",
                    "kind": "LinkedField",
                    "name": "displayPrice",
                    "plural": true,
                    "selections": [
                      (v84/*: any*/),
                      (v143/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "itemAddress",
                        "args": (v159/*: any*/),
                        "kind": "ScalarField",
                        "name": "displayCityStateCountry",
                        "storageKey": "displayCityStateCountry(fullCountryName:true)"
                      },
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isJewelry",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "leadTimeDisplay",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": "relevantAuctionLotRedirect",
                    "args": null,
                    "concreteType": "AuctionLot",
                    "kind": "LinkedField",
                    "name": "relevantAuctionLot",
                    "plural": false,
                    "selections": (v158/*: any*/),
                    "storageKey": null
                  },
                  (v33/*: any*/),
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": (v40/*: any*/),
                    "concreteType": "MetricDetailType",
                    "kind": "LinkedField",
                    "name": "metrics",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      (v59/*: any*/)
                    ],
                    "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                  },
                  (v45/*: any*/),
                  {
                    "condition": "isClient",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v164/*: any*/),
                        "kind": "ScalarField",
                        "name": "pdpTrackingVpvParams",
                        "storageKey": null
                      },
                      {
                        "alias": "makeOfferVpvParams",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "excludedPurchaseStatuses",
                            "value": [
                              "RET",
                              "CUST"
                            ]
                          },
                          (v120/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "pdpTrackingVpvParams",
                        "storageKey": null
                      },
                      (v144/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          (v131/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "medianAmount",
                            "plural": false,
                            "selections": (v103/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v103/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v103/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v170/*: any*/),
                      (v171/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AttributeValue",
                            "kind": "LinkedField",
                            "name": "framingStatus",
                            "plural": true,
                            "selections": (v42/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v173/*: any*/),
                        "concreteType": "ItemDisplayInfo",
                        "kind": "LinkedField",
                        "name": "displayInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "kind": "LinkedField",
                            "name": "ctas",
                            "plural": false,
                            "selections": [
                              (v174/*: any*/),
                              (v175/*: any*/),
                              (v176/*: any*/),
                              (v177/*: any*/),
                              (v178/*: any*/),
                              (v179/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSale",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showNet",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showUnavailable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IconicDesign",
                        "kind": "LinkedField",
                        "name": "iconicDesign",
                        "plural": false,
                        "selections": [
                          (v58/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "browsePageLinkData",
                            "plural": false,
                            "selections": [
                              (v63/*: any*/),
                              (v62/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v180/*: any*/),
                      {
                        "alias": null,
                        "args": (v147/*: any*/),
                        "kind": "ScalarField",
                        "name": "hasRequestedHoldForBuyer",
                        "storageKey": null
                      },
                      {
                        "condition": "fetchAuction",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v181/*: any*/),
                            "concreteType": "AuctionSolution",
                            "kind": "LinkedField",
                            "name": "relevantAuctionSolution",
                            "plural": false,
                            "selections": [
                              (v71/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "highestBidAmount",
                                "plural": false,
                                "selections": (v93/*: any*/),
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": "relevantAuctionSolution(page:\"pdp\")"
                          },
                          {
                            "alias": null,
                            "args": (v181/*: any*/),
                            "concreteType": "AuctionLot",
                            "kind": "LinkedField",
                            "name": "relevantAuctionLot",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "buyItNowPrice",
                                "plural": false,
                                "selections": (v93/*: any*/),
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": "relevantAuctionLot(page:\"pdp\")"
                          },
                          (v182/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "fetchPdp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "currency",
                            "variableName": "forcedCurrency"
                          },
                          (v78/*: any*/),
                          (v79/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "microdata",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "pdpMetaItems",
                        "kind": "LinkedField",
                        "name": "pdpMeta",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "index",
                            "storageKey": null
                          },
                          (v26/*: any*/),
                          (v183/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ogTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productPriceAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productPriceCurrency",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": true,
                            "selections": [
                              (v113/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageVersionType",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": (v184/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPriceUponRequest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AttributeValue",
                            "kind": "LinkedField",
                            "name": "period",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AttributeOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": (v185/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Phone",
                            "kind": "LinkedField",
                            "name": "trackedPhone",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "phoneNumber",
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v186/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotos",
                        "kind": "LinkedField",
                        "name": "viewInRoomPhotos",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "credits",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosCenterPosition",
                            "kind": "LinkedField",
                            "name": "centerPosition",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "top",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "left",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "viewInRoomPhotosComparatorWidth",
                            "kind": "LinkedField",
                            "name": "comparatorWidth",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pixel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inches",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "dealerDetailsDisplayInfo",
                        "args": null,
                        "concreteType": "ItemDisplayInfo",
                        "kind": "LinkedField",
                        "name": "displayInfo",
                        "plural": false,
                        "selections": (v187/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "kind": "LinkedField",
                        "name": "videoVimeo",
                        "plural": false,
                        "selections": [
                          (v73/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "vimeoId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v145/*: any*/),
                            "concreteType": "VideoVimeoFile",
                            "kind": "LinkedField",
                            "name": "fileByVideoSize",
                            "plural": false,
                            "selections": [
                              (v148/*: any*/)
                            ],
                            "storageKey": "fileByVideoSize(size:\"small\")"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includePlayButton",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "pad",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w100h75"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemReviewDocumentList",
                        "kind": "LinkedField",
                        "name": "reviews",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemReview",
                            "kind": "LinkedField",
                            "name": "videoReview",
                            "plural": false,
                            "selections": [
                              (v73/*: any*/),
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v183/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemMeasurement",
                        "kind": "LinkedField",
                        "name": "measurement",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "unit",
                                "value": "IN"
                              }
                            ],
                            "concreteType": "ItemConvertedMeasurementsType",
                            "kind": "LinkedField",
                            "name": "convertedMeasurements",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "convertedMeasurements(unit:\"IN\")"
                          },
                          {
                            "alias": "widthDimensions",
                            "args": [
                              (v188/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "fields",
                                "value": [
                                  "width"
                                ]
                              }
                            ],
                            "concreteType": "ItemDisplayMeasurementType",
                            "kind": "LinkedField",
                            "name": "display",
                            "plural": true,
                            "selections": (v108/*: any*/),
                            "storageKey": "display(addLabel:false,fields:[\"width\"])"
                          },
                          {
                            "alias": "heightDimensions",
                            "args": [
                              (v188/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "fields",
                                "value": [
                                  "height"
                                ]
                              }
                            ],
                            "concreteType": "ItemDisplayMeasurementType",
                            "kind": "LinkedField",
                            "name": "display",
                            "plural": true,
                            "selections": (v108/*: any*/),
                            "storageKey": "display(addLabel:false,fields:[\"height\"])"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "sortedPhotos",
                        "plural": true,
                        "selections": [
                          (v112/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "alt",
                            "storageKey": null
                          },
                          (v46/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPublishedPrivate",
                        "storageKey": null
                      },
                      (v180/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v146/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v189/*: any*/),
                      (v190/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InternalBuyLinkType",
                        "kind": "LinkedField",
                        "name": "internalBuyLinks",
                        "plural": true,
                        "selections": [
                          (v156/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anchorText",
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v173/*: any*/),
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CTADisplay",
                                "kind": "LinkedField",
                                "name": "ctas",
                                "plural": false,
                                "selections": [
                                  (v175/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "fetchAuction",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v181/*: any*/),
                        "concreteType": "AuctionLot",
                        "kind": "LinkedField",
                        "name": "relevantAuctionLot",
                        "plural": false,
                        "selections": [
                          (v73/*: any*/),
                          (v74/*: any*/),
                          (v75/*: any*/),
                          (v59/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "buyItNowPrice",
                            "plural": false,
                            "selections": (v191/*: any*/),
                            "storageKey": null
                          },
                          (v27/*: any*/),
                          (v192/*: any*/),
                          (v193/*: any*/)
                        ],
                        "storageKey": "relevantAuctionLot(page:\"pdp\")"
                      },
                      {
                        "alias": null,
                        "args": (v181/*: any*/),
                        "concreteType": "AuctionSolution",
                        "kind": "LinkedField",
                        "name": "relevantAuctionSolution",
                        "plural": false,
                        "selections": [
                          (v69/*: any*/),
                          (v59/*: any*/),
                          (v71/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "highestBidAmount",
                            "plural": false,
                            "selections": (v191/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highestBidderId",
                            "storageKey": null
                          },
                          (v68/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minNextBidAmount",
                            "plural": false,
                            "selections": (v194/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": "relevantAuctionSolution(page:\"pdp\")"
                      },
                      {
                        "alias": null,
                        "args": [
                          (v39/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "timeRanges",
                            "value": [
                              "LAST_7_DAYS"
                            ]
                          }
                        ],
                        "concreteType": "Urgency",
                        "kind": "LinkedField",
                        "name": "urgency",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "listingViews",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "urgency(metricTypes:[\"LISTING_VIEWS\"],timeRanges:[\"LAST_7_DAYS\"])"
                      },
                      (v182/*: any*/),
                      (v195/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuctionSecondChanceInfo",
                        "kind": "LinkedField",
                        "name": "auctionSecondChanceInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "offerSent",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v171/*: any*/),
                      (v170/*: any*/),
                      (v104/*: any*/),
                      {
                        "alias": "originalDisplayPrice",
                        "args": (v181/*: any*/),
                        "concreteType": "ItemDisplayPriceType",
                        "kind": "LinkedField",
                        "name": "displayPrice",
                        "plural": true,
                        "selections": (v101/*: any*/),
                        "storageKey": "displayPrice(page:\"pdp\")"
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "level",
                            "value": 1
                          }
                        ],
                        "concreteType": "Category",
                        "kind": "LinkedField",
                        "name": "getCategoriesByLevel",
                        "plural": true,
                        "selections": (v185/*: any*/),
                        "storageKey": "getCategoriesByLevel(level:1)"
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v147/*: any*/),
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "lastTransaction",
                            "plural": false,
                            "selections": [
                              (v196/*: any*/),
                              (v197/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isWinningAuctionOrder",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSecondChanceOfferActive",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "mostRecentOffer",
                                "plural": false,
                                "selections": [
                                  (v59/*: any*/),
                                  (v27/*: any*/),
                                  (v198/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MaxBidType",
                            "kind": "LinkedField",
                            "name": "auctionActiveMaxBids",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "userId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "amount",
                                "plural": false,
                                "selections": (v103/*: any*/),
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v173/*: any*/),
                            "concreteType": "SkuDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CTADisplay",
                                "kind": "LinkedField",
                                "name": "ctas",
                                "plural": false,
                                "selections": [
                                  (v176/*: any*/),
                                  (v174/*: any*/),
                                  (v177/*: any*/),
                                  (v178/*: any*/),
                                  (v179/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "kind": "LinkedField",
                        "name": "variableAttributes",
                        "plural": true,
                        "selections": [
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "kind": "LinkedField",
                            "name": "variableAttributeData",
                            "plural": false,
                            "selections": [
                              (v58/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "kind": "LinkedField",
                                "name": "primaryAttribute",
                                "plural": false,
                                "selections": (v185/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "kind": "LinkedField",
                                "name": "swatchSort",
                                "plural": true,
                                "selections": [
                                  (v162/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "kind": "LinkedField",
                                    "name": "swatch",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v58/*: any*/),
                                      (v183/*: any*/),
                                      (v99/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "ringSize",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SwatchAttributeByNameProperties",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                              (v133/*: any*/),
                                              (v132/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "material",
                                        "plural": false,
                                        "selections": (v184/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v126/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentName",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v59/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "buyerSideSkus",
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v27/*: any*/),
                          (v55/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidePrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "retailPrice",
                                "plural": false,
                                "selections": (v199/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "netPrice",
                                "plural": false,
                                "selections": (v199/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "salePrice",
                                "plural": false,
                                "selections": (v199/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v129/*: any*/),
                          (v130/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "PDP"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "leadTime",
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "kind": "LinkedField",
                            "name": "variableAttributeSelections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "kind": "LinkedField",
                                "name": "variableAttribute",
                                "plural": false,
                                "selections": (v158/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "kind": "LinkedField",
                                "name": "swatch",
                                "plural": false,
                                "selections": (v158/*: any*/),
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v147/*: any*/),
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "lastTransaction",
                        "plural": false,
                        "selections": [
                          (v197/*: any*/),
                          (v196/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Offer",
                            "kind": "LinkedField",
                            "name": "mostRecentOffer",
                            "plural": false,
                            "selections": [
                              (v198/*: any*/),
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v147/*: any*/),
                        "kind": "ScalarField",
                        "name": "hasActiveHoldForBuyer",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isBuyerCancelationPolicyVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CancelationPolicy",
                        "kind": "LinkedField",
                        "name": "cancelationPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "header",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "linkData",
                            "plural": false,
                            "selections": (v168/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v157/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v121/*: any*/),
            "concreteType": "BuyerUrgencyInfo",
            "kind": "LinkedField",
            "name": "buyerUrgencyInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalConversations",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v59/*: any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v125/*: any*/),
                  (v49/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCheckoutBlocked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v134/*: any*/),
                  (v124/*: any*/),
                  (v49/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "quantity",
                    "variableName": "itemQuantity"
                  },
                  (v200/*: any*/)
                ],
                "concreteType": "RelevantShippingInfo",
                "kind": "LinkedField",
                "name": "relevantShipping",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "kind": "LinkedField",
                    "name": "shipmentQuotes",
                    "plural": true,
                    "selections": [
                      (v27/*: any*/),
                      (v91/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "buyerServiceMethodDisplay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "totalAmount",
                        "plural": false,
                        "selections": (v194/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "kind": "LinkedField",
                        "name": "serviceMethod",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "serviceMethodType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Region",
                            "kind": "LinkedField",
                            "name": "region",
                            "plural": false,
                            "selections": (v123/*: any*/),
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "personalizedItemsList",
                "args": [
                  (v49/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 10
                  },
                  (v120/*: any*/)
                ],
                "concreteType": "PersonalizedItems",
                "kind": "LinkedField",
                "name": "personalizedItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalPersonalizedResults",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedItem",
                    "kind": "LinkedField",
                    "name": "associatedItems",
                    "plural": true,
                    "selections": [
                      (v201/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPersonalized",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": (v166/*: any*/),
                        "storageKey": null
                      },
                      (v59/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v59/*: any*/),
                  (v201/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPersonalizedItem",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds"
                  }
                ],
                "concreteType": "TransactionConnection",
                "kind": "LinkedField",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TransactionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v127/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isPrivateOffer",
                                "storageKey": null
                              },
                              (v196/*: any*/),
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "isInteractivePdpChat",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v23/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "itemRead",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              (v186/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "shippingAddress",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayCityStateCountry",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PresenceResults",
                                "kind": "LinkedField",
                                "name": "presence",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "recentOnlineDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showOnlineStatus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v195/*: any*/),
                          (v95/*: any*/),
                          {
                            "alias": "buyerChatDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v187/*: any*/),
                            "storageKey": null
                          },
                          (v189/*: any*/),
                          (v190/*: any*/)
                        ],
                        "type": "Item",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "presenceFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "presence"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"presence\")"
                  },
                  {
                    "alias": "readReceiptsFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "readReceipts"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"readReceipts\")"
                  },
                  {
                    "alias": "presenceRolloutPercentage",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "presenceRolloutPercentage"
                      },
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "graphQLConfig"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "config",
                    "storageKey": "config(key:\"presenceRolloutPercentage\",type:\"graphQLConfig\")"
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v134/*: any*/),
                          (v49/*: any*/)
                        ],
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "buyerItemConversation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasMessageFromSeller",
                            "storageKey": null
                          },
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasUnreadMessageForMember",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "originalBuyer",
                            "plural": false,
                            "selections": (v158/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "sellerMember",
                            "plural": false,
                            "selections": [
                              (v27/*: any*/),
                              (v59/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastConversationReadDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Message",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userType",
                                    "value": "BUYER"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "translatedTextBody",
                                "storageKey": "translatedTextBody(userType:\"BUYER\")"
                              },
                              (v59/*: any*/),
                              (v27/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textBody",
                                "storageKey": null
                              },
                              (v202/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdDateFormatted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fromUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shipmentTrackingNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v185/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": (v160/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedNetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadePrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeNetPriceOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionAutomatedPrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionSpecialShippingRequests",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldPlaced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldReleased",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCallInitiated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomizationOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomization",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBundledOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferHoldSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionInternalAdminJoined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMarkedShipped",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclinedApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionDealerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBuyerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isApoFromCart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expirationDate",
                                    "storageKey": null
                                  },
                                  (v198/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSubmitted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRevisedByDealer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCountered",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "amountPerItem",
                                    "plural": false,
                                    "selections": (v103/*: any*/),
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "kind": "LinkedField",
                                "name": "transaction",
                                "plural": false,
                                "selections": [
                                  (v196/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Offer",
                                    "kind": "LinkedField",
                                    "name": "mostRecentOffer",
                                    "plural": false,
                                    "selections": (v158/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TransactionSummaryObject",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "offerDiscountPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": (v158/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedback",
                                "kind": "LinkedField",
                                "name": "orderFeedback",
                                "plural": false,
                                "selections": [
                                  (v73/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "token",
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v164/*: any*/),
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v153/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Summary",
                            "kind": "LinkedField",
                            "name": "conversationSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unread",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v203/*: any*/),
                        "concreteType": "ConversationsSolrConnection",
                        "kind": "LinkedField",
                        "name": "conversationsSolr",
                        "plural": false,
                        "selections": [
                          (v70/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationsSolrEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Conversation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessage",
                                    "storageKey": null
                                  },
                                  (v202/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inboxImage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numberOfMessages",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v59/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ItemSkuType",
                                    "kind": "LinkedField",
                                    "name": "sku",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "skuPhotoWebPath",
                                        "args": (v145/*: any*/),
                                        "kind": "ScalarField",
                                        "name": "firstPhotoWebPath",
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      (v59/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessageReceivedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "hasReplied",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLatestMessageSender",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMember",
                                    "kind": "LinkedField",
                                    "name": "originalBuyer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasUnreadTag",
                                        "storageKey": null
                                      },
                                      (v59/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v59/*: any*/),
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v116/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v117/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v203/*: any*/),
                        "filters": [
                          "page",
                          "buyerId"
                        ],
                        "handle": "connection",
                        "key": "BuyerChatVariant_conversations",
                        "kind": "LinkedHandle",
                        "name": "conversationsSolr"
                      }
                    ]
                  },
                  {
                    "condition": "fetchRegionalInfo",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "regionsInfo",
                        "args": [
                          (v124/*: any*/),
                          (v200/*: any*/)
                        ],
                        "concreteType": "RegionalInfo",
                        "kind": "LinkedField",
                        "name": "regionalInfo",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RegionsByZipCode",
                            "kind": "LinkedField",
                            "name": "regionsByZipCode",
                            "plural": true,
                            "selections": [
                              (v58/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchPdp",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "videoUploadToolsFeatureFlag",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "videoUploadTools"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"videoUploadTools\")"
              },
              {
                "alias": "isPdpUrlTranslationEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "translatedPdpUrls"
                  }
                ],
                "kind": "ScalarField",
                "name": "isEnabled",
                "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
              },
              {
                "condition": "fetchPdp",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "isPdpStfEnabled",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "enablePdpStf"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"enablePdpStf\")"
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchAuction",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "similarAuctionItems",
                "args": (v205/*: any*/),
                "concreteType": "moreLikeThisItemConnection",
                "kind": "LinkedField",
                "name": "moreLikeThisItem",
                "plural": false,
                "selections": (v119/*: any*/),
                "storageKey": null
              },
              {
                "alias": "similarAuctionItems",
                "args": (v205/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "PdpRespSimilarAuctionItems_similarAuctionItems",
                "kind": "LinkedHandle",
                "name": "moreLikeThisItem"
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v164/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowSellerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowFolder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      (v82/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "measurementUnit",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v152/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/),
                  (v59/*: any*/),
                  {
                    "condition": "fetchFollowSearch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                          },
                          {
                            "kind": "Variable",
                            "name": "pages",
                            "variableName": "followSearchPages"
                          },
                          {
                            "kind": "Literal",
                            "name": "types",
                            "value": [
                              "SEARCH",
                              "USER_PREFERENCE"
                            ]
                          }
                        ],
                        "concreteType": "favoritesConnection",
                        "kind": "LinkedField",
                        "name": "favorites",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v59/*: any*/),
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__id",
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmDesignManagerProfileType",
                        "kind": "LinkedField",
                        "name": "tradeFirmDesignManagerProfile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasAccount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accountType",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "socialNetworkNames",
                            "value": "DESIGN_MANAGER"
                          }
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "socialNetworks",
                        "plural": true,
                        "selections": [
                          (v46/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v73/*: any*/)
                            ],
                            "type": "DesignManagerSocialNetworkType",
                            "abstractKey": null
                          },
                          (v157/*: any*/)
                        ],
                        "storageKey": "socialNetworks(socialNetworkNames:\"DESIGN_MANAGER\")"
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v206/*: any*/),
                          (v122/*: any*/),
                          (v59/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v164/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v122/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v206/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v164/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": (v123/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": "ENHANCED_BUYER_PROTECTION"
                                      }
                                    ],
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "childPrograms",
                                    "plural": true,
                                    "selections": (v123/*: any*/),
                                    "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isTopYmalVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "fetchPdp",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "similarLandingItems",
                    "args": [
                      (v204/*: any*/),
                      (v48/*: any*/),
                      (v77/*: any*/),
                      (v49/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "onlyAuctionItems",
                        "value": true
                      }
                    ],
                    "concreteType": "moreLikeThisItemConnection",
                    "kind": "LinkedField",
                    "name": "moreLikeThisItem",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "moreLikeThisItemMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUsingRerankedResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "moreLikeThisItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v27/*: any*/),
                              (v53/*: any*/),
                              (v54/*: any*/),
                              (v36/*: any*/),
                              (v26/*: any*/),
                              (v52/*: any*/),
                              (v167/*: any*/),
                              (v61/*: any*/),
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemCreator",
                                "kind": "LinkedField",
                                "name": "creators",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Creator",
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": (v185/*: any*/),
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v110/*: any*/),
                                "concreteType": "ItemPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v112/*: any*/),
                                  (v114/*: any*/),
                                  (v59/*: any*/),
                                  (v111/*: any*/)
                                ],
                                "storageKey": "photos(limit:1)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AuctionSolution",
                                "kind": "LinkedField",
                                "name": "relevantAuctionSolution",
                                "plural": false,
                                "selections": [
                                  (v68/*: any*/),
                                  (v69/*: any*/),
                                  (v71/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "highestBidAmount",
                                    "plural": false,
                                    "selections": (v103/*: any*/),
                                    "storageKey": null
                                  },
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AuctionLot",
                                "kind": "LinkedField",
                                "name": "relevantAuctionLot",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "buyItNowPrice",
                                    "plural": false,
                                    "selections": (v103/*: any*/),
                                    "storageKey": null
                                  },
                                  (v192/*: any*/),
                                  (v193/*: any*/),
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/441.0.0-2023-12-07T14:38:11.118Z/pdpRespRootQuery",
    "metadata": {},
    "name": "pdpRespRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "03c4e8ee59e86056e2a3c38249f33ddf";

export default node;
